import { useTranslation } from 'react-i18next';
import MaterialButton from './maker/component/MaterialButton';
import { Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert, CircularProgress } from '@mui/material';
import LoginDialog from './maker/LoginDialog';
import { useState } from 'react';
import { useContext } from 'react';
import { AppContext } from './AppContext';
import { cleanMakerQueryString, getUser, updatePlan, updateStoryOrGoToStories } from './maker/MakerController';
import { useNavigate } from 'react-router-dom';
import { analyticsManager } from '.';

function TryPremiumDialog(props) {
    const { t } = useTranslation();
    const [showLogin, setShowLogin] = useState(false);
    const fbResponse = useContext(AppContext).get("fbResponse");
    const setFbResponse = useContext(AppContext).get("setFbResponse");
    const [showAckUpgraded, setShowAckUpgraded] = useState(null);
    const [upgrading, setUpgrading] = useState(false);
    const navigate = useNavigate();

    function onLogin(user){              
        return updateStoryOrGoToStories(user, props.storyId, props.story)
            .then((navigateToLogged)=>{                               
                if (navigateToLogged) {
                    navigate("/logged"); 
                    return false;
                }
                else { 
                    cleanMakerQueryString(props.story.baseStoryId != null ? props.story.baseStoryId : props.storyId);    
                    return true;            
                }
            });
    }

    function showAckUpgradedSnack(){
        if (showAckUpgraded){            
            return (
                <Snackbar open={showAckUpgraded} autoHideDuration={4000} onClose={()=>setShowAckUpgraded(false)} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                    <Alert onClose={()=>setShowAckUpgraded(false)} severity="success" sx={{ width: '100%' }}>     
                    {t('AckUpgraded')}
                    </Alert>
                </Snackbar>
            );
        }
        else return null;
    }

    return (
        <>
            <Dialog
                open={props.open}
                onClose={()=>{if (!upgrading) props.onClose();}}
                PaperProps={{
                    style: {                        
                        padding: '20px',
                        width: 720,                        
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }
                }}
            >
                <DialogTitle style={{ textAlign: 'center' }}>
                    <img 
                        src="/images/img_cooking_wear.png" 
                        alt="a cooking wear" 
                        style={{ width: 128, height: 128 }}
                    />
                </DialogTitle>
                <DialogContent style={{ textAlign: 'center', }}>
                    <div style={{ fontSize: 18, marginBottom: 20 }}>{t('TryItPremiumTitle')}</div>
                    <div style={{ fontSize: 14,  textAlign: 'left'  }}>
                        {t('TryItPremiumText')}
                        <ul>
                            <li>{t('TryItPremiumText1')}</li>
                            <li>{t('TryItPremiumText2')}</li>
                            <li>{t('TryItPremiumText3')}</li>
                        </ul>
                    </div>                    
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    {!upgrading && <MaterialButton 
                        style="filled" 
                        onClick={() => {
                            if (!fbResponse || fbResponse.isAnonymous) {
                                setShowLogin(true);
                            }
                            else {                                     
                                setUpgrading(true);                                
                                updatePlan(fbResponse.uid, "premium", true)
                                    .then(()=>getUser(fbResponse.uid))
                                    .then((uprealityUser) => {
                                        const updatedUser = {...fbResponse};
                                        updatedUser.uprealityUser = uprealityUser;
                                        setFbResponse(updatedUser);
                                        setShowAckUpgraded(true);
                                        analyticsManager.logTryPremiumTag();
                                        props.callback();
                                    })
                                    .catch((error) => {})
                                    .finally(() => {
                                        setUpgrading(false);
                                    });
                            }  
                        }}                        
                        value={t('TryItPremium')} 
                    />}    

                    {upgrading && <CircularProgress sx={{color: '#2FC4B5', }}/>}                       
                </DialogActions>                
            </Dialog>
            {showLogin &&<LoginDialog origin="premium_dialog" title={props.title} forPremium={"premium"} customLoginButton={showLogin !== false} showLogin={showLogin} resetLoginDialog={setShowLogin} onSuccess={(result)=>{                
                onLogin(result.user).then((executeCallback) => {                    
                    if (!executeCallback) return;  
                    setUpgrading(true);                  
                    updatePlan(result.user.uid, "premium", true)
                        .then(()=> {
                            analyticsManager.logTryPremiumTag();                            
                            setShowAckUpgraded(true);                  
                            props.callback();
                        })
                        .catch((error) => {})
                        .finally(() => {
                            setUpgrading(false);
                        });
                });
            }}/>
            }
            {showAckUpgradedSnack()
            }
        </>
    );
}

export default TryPremiumDialog;